import {
	Component,
	ComponentFactoryResolver,
	OnDestroy,
	AfterViewInit,
	ViewChild,
	ElementRef,
	Input
} from '@angular/core';
import { Store } from '@ngxs/store';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
// Models
import { DOCUMENT_RULES_UI_SECTIONS, UISTATE } from '../../model/quality.constant';
import { RuleModel } from '../../rules/model/rule.model';
// Components
import { SubContentService, BroadcastService } from '@cv-invision/core';
import { RulesComponent } from '../../rules/rules.component';
import { HISTORICAL_VALUE_EVENT } from '../../historical-values/historical-values.component';
import { Structure } from './model/interfaces';
//eslint-disable-next-line
import { ViewsService } from '@cv-invision/cv.invision-views.ux';

@Component({
	selector: 'cv-cvds-structures',
	templateUrl: './cvds-structures.component.html',
	styleUrls: ['./cvds-structures.component.scss']
})
export class CvdsStructuresComponent implements AfterViewInit, OnDestroy {
	@Input() vertical = true;
	@ViewChild('contentRevised', { static: true }) contentRevised: ElementRef<any>;
	private atComponentDestroy = new Subject();
	targets = {
		data: [],
		primary: []
	};
	selectedTargets = [];
	selectedType = '';
	sections: any;

	documentOrder: any;
	documentSchema: any;
	overviewUiState: any;
	uiState: string;

	selectedSection = '';
	selectedRules: DOCUMENT_RULES_UI_SECTIONS;

	scrollT: number;

	structures = [];
	structure: Structure;
	structureIndex: number;

	constructor(
		private store: Store,
		private subContentService: SubContentService,
		private componentFactoryResolver: ComponentFactoryResolver,
		private broadcastService: BroadcastService,
		private viewService: ViewsService
	) {
		this.overviewUiState = UISTATE;
		this.store
			.select(s => s.quality)
			.pipe(takeUntil(this.atComponentDestroy))
			.subscribe(quality => {
				if (quality && quality.documentOrder && quality.documentSchema) {
					this.documentSchema = quality.documentSchema;
					this.documentOrder = quality.documentOrder;
					this.uiState = UISTATE.IS_READY;
					this.viewService.setSchema(quality.documentSchema);
					this.loadData();
				}
			});
	}

	/**
	 * Load Data after order and schema is ready
	 *
	 */
	private loadData(): void {
		const {
			InspectionReport: {
				property: { structures }
			}
		} = this.documentOrder;
		this.structures = structures;
		if (structures.length) {
			this.onStructureChanged(0);
		}
	}

	/**
	 * Load the 1004  Rules through store managment and then open the Rules SubContent panel.
	 *
	 */
	private loadRules(): void {
		this.subContentService
			.open({
				componentFactoryResolver: this.componentFactoryResolver,
				component: RulesComponent,
				data: {
					uiSection: this.selectedRules,
					targets: this.targets
				}
			})
			.subscribe(updateEvent => {
				this.getSelectedRule(updateEvent);
			});
	}

	/**
	 * set structure
	 * @param $index
	 */
	onStructureChanged(index: number): void {
		this.structure = null;
		this.structureIndex = index;
		setTimeout(() => {
			this.structure = this.structures[index];
		}, 200);
	}

	/**
	 * get the rule selected
	 * @param item selected rule model
	 */
	getSelectedRule(item: RuleModel): void {
		this.selectedTargets = [];
		this.selectedTargets = item.targets;
		this.selectedType = item.messageType;
	}

	/**
	 * get scroll event
	 * @param $event
	 */
	onScroll(event: any): void {
		const target = event.target as Element;
		const isHistoricalCmp = target.classList.contains('cv-historical-values__container');

		if (!isHistoricalCmp) {
			const { scrollTop } = event.target;
			this.scrollT = scrollTop;
			this.broadcastService.broadcast({
				name: HISTORICAL_VALUE_EVENT,
				event: {
					isOpen: false,
					data: [],
					pos: {}
				}
			});
		}
	}

	ngAfterViewInit(): void {
		const el = this.contentRevised.nativeElement;
		// why this instead of hotlistener, scroll event dont work so well with that
		if (el) {
			el.addEventListener('scroll', this.onScroll.bind(this), true);
		}
	}

	/**
	 * Close all when the element is destroyed
	 * in case a Sub Component remains visible
	 */
	ngOnDestroy(): void {
		// Globally Destroy anything attached to it
		this.atComponentDestroy.next({});
		this.atComponentDestroy.unsubscribe();
	}
}
